import { render } from "./ContentBlocks.vue?vue&type=template&id=4adcc914"
import script from "./ContentBlocks.vue?vue&type=script&lang=js"
export * from "./ContentBlocks.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__